export function baseUrl(isNewApi, maybeBaseUrl) {
    var maybeTestkitUrl = process.env.NODE_ENV === 'test' && isNewApi && 'http://localhost:5700';
    return maybeBaseUrl || maybeTestkitUrl || '';
}
//# sourceMappingURL=base-url.js.map